import URLConst from '../constants/URLConst';
import { fetchJSON, securePOST } from '../utilities/FetchHelper';

class RecapService {
    
    postRecap(hotelCode) {
        let url = URLConst.HOTEL_ONBOARDING_SERVICE + URLConst.PATH_HOTEL_RECAP_POST
        url = url.replace('{hotelCode}', hotelCode)

        return fetchJSON(url, { ...securePOST(), body: " " })
        .then(response => {
            return response
        }).catch((error) => {
            throw error
        })
    }
}

export default new RecapService()